export default __webpack_public_path__ + "static/media/logo.a847d376.jpg";